import { render, staticRenderFns } from "./TVConfigEventName.vue?vue&type=template&id=3db22652&scoped=true"
import script from "./TVConfigEventName.vue?vue&type=script&lang=js"
export * from "./TVConfigEventName.vue?vue&type=script&lang=js"
import style0 from "./TVConfigEventName.vue?vue&type=style&index=0&id=3db22652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db22652",
  null
  
)

export default component.exports